import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  label,
  error,
  helperText,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-1632">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1633">
            {label}
          </label>}
        <input ref={ref} className={`w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-sm text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback focus:border-transparent ${className}`} {...props} data-id="element-1634" />
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-1635">{error}</p>}
        {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-1636">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';